import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
 
@Injectable({
  providedIn: 'root'
})
export class LoaderService {
 
  loadingRef: any = null;
  constructor(private loadingController: LoadingController) { }
  // simpleLoader() {
  //   this.loadingController.create({
  //       message: 'Loading...'
  //   }).then((response) => {
  //       response.present();
  //   });
  // }
 
 
  async simpleLoader() {
    const loader = await this.loadingController.create({
      message: '', // Hide default message
      spinner: null, // Disable Ionic spinner
      cssClass: 'custom-gif-loader' // Custom class to apply your gif
    });
 
    await loader.present();
  }
  
  loaderActive() {
    this.loadingController.create({
      message: '', // Hide default message
      spinner: null, // Disable Ionic spinner
      cssClass: 'custom-gif-loader' // Custom class to apply your gif
    }).then( (res) => {
      res.present();
    });
  }
 
  // simpleLoaderWithDuration() {
  //   this.loadingController.create({
  //     duration: 3000,
  //     message: 'Loading...'
  //   }).then((response) => {
  //     response.present();
  //   });
  // }
 
 
  simpleLoaderWithDuration() {
    this.loadingController.create({
      duration: 3000,
      message: '',
      spinner: null,
      cssClass: 'custom-gif-loader'
    }).then((response) => {
      response.present();
    });
  }
  // Dismiss loader
  // dismissLoader() {
  //   this.loadingController.dismiss().then((response) => {
  //     console.log('Loader closed!', response);
  //   }).catch((err) => {
  //     console.log('Error occured : ', err);
  //   });
  // }
 
  dismissLoader() {
    this.loadingController.dismiss().then((response) => {
      // console.log('Loader closed!', response);
    }).catch((err) => {
      // console.log('Error occured : ', err);
    });
  }
}